import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Button, NamedLink } from '../../components';

import css from './ModalMissingInformation.module.css';

const MissingInfoReminder = props => {
    const {
        className,
    } = props;

    return (
        <div className={className}>
            <p className={css.modalTitle}>
                <FormattedMessage id="ModalMissingInformation.MissingInfoReminderTitle" />
            </p>
            <p className={css.modalMessage}>
                <FormattedMessage id="ModalMissingInformation.MissingInfoReminderText" />
            </p>
            <NamedLink
                name="ProfileSettingsPage"
            >
                <Button className={css.actionButton}><FormattedMessage id="ModalMissingInformation.MissingInfoReminderButton" /></Button>
            </NamedLink>
        </div>
    );
};

export default MissingInfoReminder;
